import { Timeout } from 'src/types';

export function debounce<F extends (...args: any[]) => any>(
  f: F,
  delayMs: number,
): (...args: Parameters<F>) => Promise<ReturnType<F>> {
  let timeout: Timeout | undefined;

  return async (...args: Parameters<F>): Promise<ReturnType<F>> => {
    if (timeout) clearTimeout(timeout);

    return new Promise<ReturnType<F>>(resolve => {
      timeout = setTimeout(() => {
        const returnValue = f(...args) as ReturnType<F>;
        resolve(returnValue);
      }, delayMs);
    });
  };
}
